import { InjectionToken } from "@angular/core";
import { IReceiverAuthenticationWsClient } from "./i-receiver-authentication-ws.client";

export const receiverAuthenticationWsClientInjectionToken: InjectionToken<IReceiverAuthenticationWsClient> = new InjectionToken<IReceiverAuthenticationWsClient>("digital-signage.user-dashboard.dashboard-web.ReceiverAuthenticationWsClient");
